import React, { useState, useEffect } from "react";
import "./Body.css";

export default function Body({ userData }) {
  const [bodyVector, setBodyVector] = useState(null);

  useEffect(() => {
    if (userData.weight !== 0 && userData.height !== 0) {
      const heightSquare = (userData.height / 100) * (userData.height / 100);
      const BMIResult = userData.weight / heightSquare;
      if (BMIResult < 18.5) {
        setBodyVector("/images/underWeight.png");
      } else if (BMIResult > 18.5 && BMIResult < 24.9) {
        setBodyVector("/images/normalWeight.png");
      } else if (BMIResult > 25 && BMIResult < 29.9) {
        setBodyVector("/images/overWeight.png");
      } else if (BMIResult > 30 && BMIResult < 34.9) {
        setBodyVector("/images/fat.png");
      } else if (BMIResult > 35) {
        setBodyVector("/images/excessiveObesity.png");
      }
    } else {
      console.log("falsy values");
    }
  }, [userData]);
  
  return (
    <div className="myBodyLeft centeredFlex">
      {bodyVector !== null && (
        <>
          <img
            src={bodyVector}
            alt="body"
            className="myBodyImg"
            style={
              bodyVector.includes("fat") ||
              bodyVector.includes("excessiveObesity")
                ? { width: "3.2rem" }
                : { width: "2.8rem" }
            }
          />
          <img
            src="/images/heart.svg"
            alt="heart"
            className="heartIcon"
            style={
              bodyVector.includes("underWeight")
                ? { top: "3.2rem", left: "calc(50% + 1.4rem)" }
                : bodyVector.includes("normalWeight")
                ? { top: "3.3rem", left: "calc(50% + 1.4rem)" }
                : bodyVector.includes("overWeight")
                ? { top: "3rem", left: "calc(50% + 1.3rem)" }
                : bodyVector.includes("fat")
                ? { top: "3rem", left: "calc(50% + 1.5rem)" }
                : bodyVector.includes("excessiveObesity")
                ? { top: "3.3rem", left: "calc(50% + 1.7rem)" }
                : { top: "3.3rem", left: "calc(50% + 1.4rem)" }
            }
          />
        </>
      )}
      <div className="heightWeightWrapper centeredFlex">
        <div className="centeredFlex">
          <span className="myBodyHeight">
            {userData.height ? Math.floor(userData.height) : 0} cm
          </span>
          <div className="whiteLine"></div>
        </div>
        <span className="myBodyWeight">
          {userData.weight ? Math.floor(userData.weight) : 0} kg
        </span>
      </div>
    </div>
  );
}
